<template>
  <div class="page">
    <div class="ctrl">
      <router-link :to="'/activity/create?exh_id=' + exh_id"
        ><a-button type="primary">添加活动</a-button></router-link
      >
    </div>
    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="time" slot-scope="text, record">
        {{ record.start_at }} --
        <br />
        {{ record.end_at }}
      </template>

      <template slot="join_time" slot-scope="text, record">
        {{ record.join_start }} --
        <br />
        {{ record.join_end }}
      </template>

      <template slot="need_join" slot-scope="text, record">
        <a-icon v-if="record.need_join" type="check" />
      </template>

      <template slot="need_app" slot-scope="text, record">
        <a-icon v-if="record.need_app" type="check" />
      </template>

      <template slot="status" slot-scope="text, record">
        <a-tag :color="record.status_color">{{ record.status }}</a-tag>
      </template>

      <template slot="section" slot-scope="text, record">
        <router-link :to="'/activity/section/list?activity_id=' + record.id"
          >查看</router-link
        >
      </template>

      <template slot="form" slot-scope="text, record">
        <router-link :to="'/activity/form/list?activity_id=' + record.id"
          >查看</router-link
        >
      </template>

      <template slot="join" slot-scope="text, record">
        <router-link :to="'/activity/join/list?id=' + record.id"
          >查看</router-link
        >
      </template>

      <template slot="coupon" slot-scope="text, record">
        <router-link :to="'/activity/coupon/list?id=' + record.id"
          >查看</router-link
        >
      </template>

      <template slot="yaoqing" slot-scope="text, record">
        <router-link v-if="record.yaoqing == 1" :to="'/activity/yaoqing/list?id=' + record.id"
          >查看</router-link
        >
      </template>

      <template slot="action" slot-scope="text, record">
        <router-link :to="'/activity/info?id=' + record.id">详情</router-link>
        <a-divider type="vertical" />
        <router-link :to="'/activity/update?id=' + record.id">编辑</router-link>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link"> 状态 <a-icon type="down" /> </a>
          <a-menu slot="overlay">
            <a-menu-item
              v-for="(status, index) in statusList"
              :key="index"
              @click="updateStatus(record.id, status)"
              >{{ status }}</a-menu-item
            >
          </a-menu>
        </a-dropdown>
      </template>
    </a-table>

    <a-pagination
      class="pagination"
      showQuickJumper
      v-model="page.now_page"
      :defaultPageSize="page.page_size"
      :total="page.amount"
      @change="changePage"
    />
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
const columns = [
  {
    title: "#",
    dataIndex: "id",
  },
  {
    title: "贝展",
    dataIndex: "exh_title",
  },
  {
    title: "活动",
    dataIndex: "name",
  },
  {
    title: "场地",
    dataIndex: "place",
  },
  {
    title: "主办方",
    dataIndex: "zhuban",
  },
  {
    title: "报名费",
    dataIndex: "fee",
  },
  {
    title: "贝展时间",
    scopedSlots: {
      customRender: "time",
    },
  },
  {
    title: "报名时间",
    scopedSlots: {
      customRender: "join_time",
    },
  },
  {
    title: "需要报名",
    scopedSlots: {
      customRender: "need_join",
    },
  },
  {
    title: "需要审核",
    scopedSlots: {
      customRender: "need_app",
    },
  },
  {
    title: "总人数",
    dataIndex: "amount_limit",
  },
  {
    title: "每人限报",
    dataIndex: "join_limit",
  },
  {
    title: "优惠券",
    dataIndex: "coupon_name",
  },
  {
    title: "环节",
    scopedSlots: {
      customRender: "section",
    },
  },
  {
    title: "报名表单",
    scopedSlots: {
      customRender: "form",
    },
  },
  {
    title: "邀请",
    scopedSlots: {
      customRender: "yaoqing",
    },
  },
  {
    title: "报名记录",
    scopedSlots: {
      customRender: "join",
    },
  },
  {
    title: "状态",
    scopedSlots: {
      customRender: "status",
    },
  },
  {
    title: "操作",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export default {
  data() {
    return {
      columns,
      exh_id: null,
      list: [],
      statusList: ["未开放", "报名中", "活动中", "已完成", "已删除"],
      page: {
        now_page: 1,
        page_size: 50,
        amount: 0,
      },
    };
  },
  created() {
    this.exh_id = this.$route.query.exh_id || null;
    this.getList();
  },
  methods: {
    changePage(e) {
      this.page.now_page = e;
      this.getList();
    },

    async getList() {
      const page = this.page.now_page;
      const r = await this.$axios.get("/activity/getList", {
        params: {
          page,
          exh_id: this.exh_id
        },
      });

      if (r.status != 1) return;

      this.list = r.list;
      this.page.amount = r.amount;
    },

    async updateStatus(id, status) {
      const r = await this.$axios.post("/activity/updateStatus", {
        id,
        status,
      });

      if (r.status == 1) this.getList();
    },
  },
};
</script>